import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="field-grid-light bg-cream-100 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-195" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-196" data-mp="2vqr69zq2hz5k">
        <div className="text-center" data-id="element-197" data-mp="2vownaqycwh44">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-forest-950 sm:text-4xl" data-id="element-198" data-mp="39hvyigr3vp5v">
            ¿Te suena conocido esto?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-earth-900" data-id="element-199" data-mp="35idgbsqo5s6q">
            Domingo a las 11 de la noche. Mañana tienes clase de minería. Y todavía estás buscando cómo explicar la
            diferencia entre minería a cielo abierto y subterránea, cómo funcionan los métodos de explotación o por qué
            la seguridad minera es importante sin que tus alumnos se duerman o no entiendan nada.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-earth-700" data-id="element-200" data-mp="jddb84xia6ty">
            No es tu culpa. Es que llevas años peleando con materiales desorganizados, teoría densa en libros viejos y
            recursos pensados para otros contextos que después tienes que reescribir entero.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-earth-200 bg-white p-6 shadow-sm shadow-earth-900/5 sm:p-8" data-id="element-201" data-mp="x5juw0zvavy5">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-xl font-bold tracking-tight text-forest-950" data-id="element-202" data-mp="1c2kaj64sb0g9">
            <AlertTriangleIcon className="h-5 w-5 text-earth-700" aria-hidden="true" data-id="element-203" data-mp="3dt5ioh1f54kg" />
            El costo de no tener el material correcto:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-204" data-mp="3hviof5g612h8">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-earth-900" data-id="element-205" data-mp="p1bpttcmn0rt">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-600" aria-hidden="true" data-id="element-206" data-mp="k27il899jd44" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-207" data-mp="tz3qpcv91x85">
          <p className="text-lg font-bold text-earth-800" data-id="element-208" data-mp="u1galvkkihnu">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tienes. Ahora te falta la herramienta.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold tracking-tight text-forest-950 sm:text-3xl" data-id="element-209" data-mp="12zigopj5s0hz">
            Planifica todo tu año{' '}
            <span className="text-forest-800 underline decoration-gold-500 decoration-4 underline-offset-4" data-id="element-210" data-mp="1cq3dq8j6owys">hoy.</span>
          </p>
        </div>
      </div>
    </section>;
}